import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/@desktop/(app)/create/page.tsx");
